import { AIRole, Intent } from "./types";

export const INTENTS = {
  NEW_SUBSCRIPTION: "newSubscription" as Intent,
  PAUSE_SUBSCRIPTION: "pauseSubscription" as Intent,
  CANCEL_SUBSCRIPTION: "cancelSubscription" as Intent,
  UPDATE_SUBSCRIPTION: "updateSubscription" as Intent,
  RESUME_SUBSCRIPTION: "resumeSubscription" as Intent,
};

export const AI_ROLES = {
  USER: "user" as AIRole,
  ASSISTANT: "assistant" as AIRole,
};

export const INTERRUPTION_MESSAGES = {
  [INTENTS.PAUSE_SUBSCRIPTION]:
    "Please confirm the following information to pause the subscription:",
};
